import request from '@/utils/request'

export const submit = (interfacePackageId) => {
  return request.put('/pay/submit/10/' + interfacePackageId)
}

export const submitBookMatch = (taskId) => {
  return request.put('/pay/submit/30/' + taskId)
}

export const getByOrderNo = (orderNo) => {
  return request.get('/pay/getByOrderNo/' + orderNo)
}

export const getOrderPage = (current, size) => {
  return request.get('/client/order/page', {
    params: {
      current,
      size
    }
  })
}
